'use client'

import Script from 'next/script'
import { type FC } from 'react'

import { ODS_CLIENT_SCRIPT_ID } from '../const.ts'
import { loadVariablesToWindow } from '../loadVariablesToWindow.ts'

export const OnlineDoctorClientPage: FC<{
  baseUrl: string
  src: string
}> = ({ baseUrl, src }) => {
  return (
    <>
      <Script
        onLoad={() => {
          loadVariablesToWindow(baseUrl)
        }}
        src={src}
      />
      <div className="size-full" id={ODS_CLIENT_SCRIPT_ID} />
    </>
  )
}
